export enum ChestType {
	EXPLORE = "EXPLORE",
	INTEL = "INTEL",
	RETURN = "RETURN",
	REWARDED_AD = "REWARDED_AD",
	SPECIAL = "SPECIAL",
	FIXED = "FIXED",
}

export type ChestReward = {
	coins: number;
	superClicker?: number;
	gems?: number;
};

export type Chest = {
	id: string;
	type: ChestType;
	x: number;
	y: number;
	reward: ChestReward;
	specialReward?: ChestReward;
	expiresAt?: number;
};

export type SpecialChest = Chest & {
	type: ChestType.SPECIAL;
	specialReward: ChestReward;
};
